import { render, staticRenderFns } from "./ProductInspirationalImages.vue?vue&type=template&id=d1aa9dae&"
import script from "./ProductInspirationalImages.ts?vue&type=script&lang=ts&"
export * from "./ProductInspirationalImages.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports